import { render, staticRenderFns } from "./ChargeInfo.vue?vue&type=template&id=efb7a61a&scoped=true&"
import script from "./ChargeInfo.vue?vue&type=script&lang=js&"
export * from "./ChargeInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChargeInfo.vue?vue&type=style&index=0&id=efb7a61a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb7a61a",
  null
  
)

export default component.exports